/**
 * Batch E commit E1 — Conversation surfaces mobile-first layout.
 *
 * Phone-first route: `/agent/conversations` shows the conversation list
 * full-screen. Tapping an entry navigates to `/agent/conversations/:id`
 * (the thread route). On tablet/desktop, AgentWorkspace already provides
 * a multi-column view at `/agent`, so this page primarily serves the
 * phone breakpoint — but mounting it directly at any width is still
 * valid (e.g. deep-linking the list from a push notification).
 *
 * Implementation: the existing `<ConversationList />` module already
 * tracks selection through the store and renders ConversationListItem
 * buttons. We wrap it here and observe the store's selectedId — when
 * it changes (from null) we push the user to the thread route.
 */
import { useEffect, useRef, type JSX } from 'react'
import { useNavigate } from 'react-router'
import ConversationList from '../../../modules/conversations/ConversationList.js'
import { useConversationsStore } from '../../../store/conversationsStore.js'

export default function ConversationListPage(): JSX.Element {
  const selectedId = useConversationsStore((s) => s.selectedId)
  const navigate = useNavigate()

  // When the user taps a row inside ConversationList, the module flips
  // `selectedId` in the store. Translate that into a route push to the
  // active conversation tab view.
  const prevSelectedId = useRef(selectedId)
  useEffect(() => {
    if (selectedId !== null && selectedId !== prevSelectedId.current) {
      prevSelectedId.current = selectedId
      navigate(`/agent/conversation/view/${selectedId}`)
    }
  }, [selectedId, navigate])

  return (
    <div className="flex h-full min-h-0 flex-col bg-white">
      <ConversationList />
    </div>
  )
}
